import { GETTER_IS_LOADING, GETTER_ACCOUNT_GROUPS, GETTER_OPENED_ACCOUNT, GETTER_MESSAGE_ERROR } from './types';

export default {
  [GETTER_IS_LOADING]: ({ isLoading }) => isLoading,
  [GETTER_ACCOUNT_GROUPS]: ({ accountGroups }) => accountGroups,
  [GETTER_OPENED_ACCOUNT]: ({ openedAccount }) => openedAccount,
  [GETTER_MESSAGE_ERROR]: ({ businessError }) => businessError,
};
